// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductsNotFound_categories__-xX10 {
  display: inline-block; /* Safari */
  text-decoration-line: underline;
}`, "",{"version":3,"sources":["webpack://./src/views/Search/ProductsNotFound/ProductsNotFound.module.scss"],"names":[],"mappings":"AAGA;EACE,qBAAA,EACA,WAAA;EACA,+BAAA;AAFF","sourcesContent":["@use 'styles/colors';\n@use 'styles/typography';\n\n.categories{\n  display: inline-block;\n  -webkit-text-decoration-line: underline; /* Safari */\n  text-decoration-line: underline; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categories": `ProductsNotFound_categories__-xX10`
};
export default ___CSS_LOADER_EXPORT___;
